import { NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignupComponent } from './signup.component';

import { StartComponent } from './start/start.component';

import { AccountComponent } from './account/account.component';
import { CandidateComponent } from './applicant/candidate.component';
import { CredentialingComponent } from './credentialing/credentialing.component';
import { PackageComponent } from './package/package.component';
import { PaymentComponent } from './payment/payment.component';
import { LoginCredentialingComponent } from '@app/account/credentialing/credentialing.component';
import { OnlineComponent } from '@app/signup/online/online.component';
import { InviteComponent } from '@app/signup/invite/invite.component';
import { ForwardComponent } from '@app/forward/forward.component';

const routes: Routes = [
    {
        path: '', component: SignupComponent,
        children: [
            { path: 'start', component: StartComponent },
            { path: 'account', component: AccountComponent },
            { path: 'applicant', component: CandidateComponent },
            { path: 'online', component: OnlineComponent},
            { path: 'invite', component: InviteComponent},
            { path: 'credentialing', component: CredentialingComponent },
            { path: 'package', component: PackageComponent },
            { path: 'payment', component: PaymentComponent },
            { path: 'contact', component: ForwardComponent },
        ]
        
    },
    { path: 'account/credentialing', component: LoginCredentialingComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignupRoutingModule { }
